"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cerveteri": {
    "283f3720": [{
      "hkey": "0058c6da",
      "slug": "campo-di-mare",
      "name": "Campo di Mare",
      "primary": true,
      "skipSearch": false
    }],
    "campo-di-mare": [{
      "hkey": "0058c6da",
      "slug": "campo-di-mare",
      "name": "Campo di Mare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "marina-di-cerveteri"
    }],
    "6ee039e3": [{
      "hkey": "86467e09",
      "slug": "cerenova",
      "name": "Cerenova",
      "primary": true,
      "skipSearch": false
    }],
    "cerenova": [{
      "hkey": "86467e09",
      "slug": "cerenova",
      "name": "Cerenova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "marina-di-cerveteri"
    }]
  }
};
exports["default"] = _default;